import React from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import ReactTable from "react-table";
import moment from "moment";
import { Button, ButtonGroup } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Popconfirm } from "antd";
import { openCustomModal, closeCustomModal } from "components/custom/modals";
import CommentModal from "components/menu/master-files/workers-maintenance/worker-profile-components/comment-modal";
import {
    getComments,
    deleteComment
} from "api/menu/master-files/workers-maintenance/actions";

class TabWorkerComments extends React.Component {
    constructor(props) {
        super(props);

        this.handleOpenComment = this.handleOpenComment.bind(this);
        this.handleDelete = this.handleDelete.bind(this);

        if (this.props.workerId) {
            this.props.getComments(this.props.workerId);
        }
    }

    handleOpenComment (commentId = false) {
        const {
            isEditable,
            workerId
        } = this.props;

        const modalObj = {
            id: `worker-comment-${commentId}`,
            header: "Comment",
            modalSettings: {
                size: "md"
            },
            children: (
                <CommentModal
                    commentId={commentId}
                    workerId={workerId}
                    isEditable={isEditable}
                    onCancel={() => this.props.closeCustomModal(modalObj)}
                    onSubmit={() => this.props.closeCustomModal(modalObj)}
                />
            ),
            handleClose: () => this.props.closeCustomModal(modalObj)
        };
        this.props.openCustomModal(modalObj);
    }

    handleDelete = (commentId) => {
        const { workerId } = this.props;
        this.props.deleteComment(workerId, commentId);
    };

    render () {
        const {
            isEditable,
            workerId,
            comments
        } = this.props;

        if (!workerId) {
            return (
                <div
                    className="d-flex justify-content-center align-items-center"
                    style={{
                        minHeight: 150
                    }}
                >
                    Need to create worker for seeing comments
                </div>
            );
        }

        return (
            <div className="mt-2 pb-2">
                {!isEditable || (
                    <div className="text-right mb-2">
                        <button
                            className="btn btn-sm btn-warning"
                            onClick={() => this.handleOpenComment()}
                        >
                            Add Comment
                        </button>
                    </div>
                )}
                <ReactTable
                    data={comments}
                    headerClassName="table-header"
                    columns={[
                        {
                            Header: "Subject",
                            Cell: ({ original }) =>
                                original.subject
                        },
                        {
                            Header: "Entered By",
                            Cell: ({ original }) =>
                                original.enteredBy
                        },
                        {
                            Header: "Date",
                            Cell: ({ original }) => {
                                const date = moment(original.enteredDate).format("MMMM DD, YYYY");
                                return <span>{`${date}`}</span>;
                            },
                        },
                        {
                            Header: "Actions",
                            id: "actions",
                            className: "d-flex justify-content-center align-items-center",
                            Cell: ({ original }) => {
                                if (!isEditable) {
                                    return (
                                        <Button
                                            size="sm"
                                            onClick={() =>
                                                this.handleOpenComment(original.id)}
                                        >
                                            <FontAwesomeIcon icon="eye" title="View" />
                                        </Button>
                                    );
                                }
                                return  (
                                    <ButtonGroup>
                                        <Button
                                            size="sm"
                                            onClick={() =>
                                                this.handleOpenComment(original.id)}
                                        >
                                            <FontAwesomeIcon icon="pen" title="Update" />
                                        </Button>
                                        <Popconfirm
                                            title={`Delete "${original.subject}"?`}
                                            onConfirm={() => this.handleDelete(original.id)}
                                            placement="bottomRight"
                                            okText="Yes"
                                            cancelText="Cancel"
                                        >
                                            <Button variant="danger" size="sm">
                                                <FontAwesomeIcon icon="times" />
                                            </Button>
                                        </Popconfirm>
                                    </ButtonGroup>
                                );
                            },
                            filterable: false,
                            width: 100
                        }
                    ]}
                    defaultPageSize={10}
                    className="-striped -highlight"
                    NoDataComponent={() => null}
                />
            </div>
        );
    }
}

TabWorkerComments.defaultProps = {
    isEditable: false
};

TabWorkerComments.propTypes = {
    workerId: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]).isRequired,
    tabKey: PropTypes.string.isRequired,
    getEmployeeValue: PropTypes.func.isRequired,
    isEditable: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
    comments: state.workersMaintenance.comments,
});

const mapStateToDispatch = dispatch => ({
    openCustomModal: bindActionCreators(openCustomModal, dispatch),
    closeCustomModal: bindActionCreators(closeCustomModal, dispatch),

    getComments: bindActionCreators(getComments, dispatch),
    deleteComment: bindActionCreators(deleteComment, dispatch),
});

export default connect(
    mapStateToProps,
    mapStateToDispatch,
)(TabWorkerComments);
